import React, { useEffect, useState, useRef } from "react";
import { Row, Col, Tabs, Tab, Nav, Spinner } from "react-bootstrap";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect,
  useParams,
  useRouteMatch,
} from "react-router-dom";

import API from "../Utility";
import AuthenticatedRoute from "../AuthenticatedRoute/AuthenticatedRoute";
import ThemeView from "../ThemeView/ThemeView";
import GeneralSettingsView from "../GeneralSettingsView/GeneralSettingsView";
import EmailsView from "../EmailsView/EmailsView";

import "./SettingsView.scss";

function General() {
  return (
    <div>
      <h3>General component goes here</h3>
    </div>
  );
}

export default function ConfigurationView() {
  let { project, siteId } = useParams();
  let { path, url } = useRouteMatch();
  const [projectObject, setProjectObject] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  async function getLearningCentre(query) {
    setIsLoading(true);
    const data = await API.get({
      url: query.url,
      params: query.params,
    });
    setProjectObject(data);
    setIsLoading(false);
  }

  const loading = () => {
    return (
      <div className="w-100 text-center">
        <Spinner animation="border" />
      </div>
    );
  };

  useEffect(() => {
    async function initializeData() {
      await getLearningCentre({
        url: `/admin/${project}`,
      });
    }

    initializeData();
  }, []);

  return (
    <Row>
      <Col>
        <h2>Settings</h2>
        <div className="tab-links">
          <Link
            className={
              window.location.pathname === `/settings/${project}`
                ? "active"
                : ""
            }
            to={`${url}`}
          >
            General
          </Link>
          {projectObject._id && !projectObject?.config?.hidePH &&
            (
              <Link
                className={
                  window.location.pathname === `/settings/${project}/theme`
                    ? "active"
                    : ""
                }
                to={`${url}/theme`}
              >
            Theme
              </Link>
            )
          }
          <Link
            className={
              window.location.pathname === `/settings/${project}/email`
                ? "active"
                : ""
            }
            to={`${url}/email`}
          >
            Email
          </Link>
        </div>
        <div className="tab-content">
          {projectObject && projectObject._id ? (
            <Switch>
              <AuthenticatedRoute exact path={path}>
                <GeneralSettingsView
                  projectObject={projectObject}
                  setProjectObject={setProjectObject}
                />
              </AuthenticatedRoute>
              <AuthenticatedRoute path={`${path}/theme`}>
                <ThemeView
                  projectObject={projectObject}
                  setProjectObject={setProjectObject}
                />
              </AuthenticatedRoute>
              <AuthenticatedRoute path={`${path}/email`}>
                <EmailsView
                  projectObject={projectObject}
                  setProjectObject={setProjectObject}
                />
              </AuthenticatedRoute>
              {/* TODO: remove redirect once more settings are available */}
              <Redirect to={`${url}/theme`} />
            </Switch>
          ) : (
            loading()
          )}
        </div>
      </Col>
    </Row>
  );
}
